module.exports = __webpack_public_path__ + "img/device.9b8a5373.webp";